import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { strings } from '/imports/strings';
import { css } from '/imports/ui/css';
import { Icon } from '/imports/ui/Icon';
import { useFind, useSubscribed, useUser } from '/imports/hooks';
import { Publications } from '/imports/publications';
import { MessageReceipts } from '/imports/api/messages';
import { rememberLandingPath } from '/imports/ui/Nav';

const FooterNavStyled = styled.div`
  position: relative;
  padding: 0.5rem 1rem;
  border-top: 2px solid ${css.black};
  background: ${css.white};
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  height: ${css.footerNavHeight};
  a {
    position: relative;
    text-align: center;
    text-decoration: none;
    font-size: 0.8rem;
    color: ${css.black};
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    i {
      display: flex;
      justify-content: center;
    }
  }
  .badge {
    position: absolute;
    display: flex;
    justify-content: center;
    top: 0;
    right: 0;
    background: ${css.primaryColor};
    color: ${css.white};
    height: 1rem;
    border-radius: 0.75rem;
    padding: 0.2rem 0.4rem;
    font-size: 0.8rem;
    font-weight: bold;
    ${css.flexVerticalCenter};
    &.cart {
      right: -1rem;
    }
  }
  [icon=warning] {
    position: absolute;
    top: 0;
    right: 0;
  }
`;


/** Bottom navigation bar with messages (unread badge) and manage links. */
export const FooterNav = () => {
  const user = useUser();
  const userId = user?._id;
  const orgId = user?.orgId;
  const loadingUnreads = useSubscribed(Publications.unreadMessageReceipts);
  const unreads = useFind(() => MessageReceipts.find({ userId }), [orgId, loadingUnreads]);
  const numUnread = unreads.length;
  return (
    <FooterNavStyled>
      <Link to="/messages" onClick={() => rememberLandingPath(user, '/messages')}><i><Icon icon="chat" size={24} /></i>{numUnread && <span className="badge">{numUnread}</span> || null}{strings.Messages()}</Link>
      <Link to="/manage" onClick={() => rememberLandingPath(user, '/manage')}><i><Icon icon="manageAccounts" size={24} /></i>{user?.isSuperUser ? strings.Manage() : strings.Settings()}</Link>
    </FooterNavStyled>
  );
};